export const quoteMap = {
  GET_ALL_QUOTE_START: "GET_ALL_QUOTE_START",
  GET_ALL_QUOTE_SUCCESS: "GET_ALL_QUOTE_SUCCESS",
  GET_ALL_QUOTE_ERROR: "GET_ALL_QUOTE_ERROR",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  SET_QUOTE_BATCH_NUMBER: "SET_QUOTE_BATCH_NUMBER",
  GET_QUOTE_START: "GET_QUOTE_START",
  GET_QUOTE_SUCCESS: "GET_QUOTE_SUCCESS",
  GET_QUOTE_ERROR: "GET_QUOTE_ERROR",
  SELECT_QUOTE_DETAILS: "SELECT_QUOTE_DETAILS",
  GET_QUOTE_PAGE_NAME_LIST_SUCCESS: "GET_QUOTE_PAGE_NAME_LIST_SUCCESS",
  SET_AUDIO_TYPE: "SET_AUDIO_TYPE",
  SET_LEAD_TYPE: "SET_LEAD_TYPE",
  SET_CALL_OUTCOME_FILTER: "QUOTE_SET_CALL_OUTCOME_FILTER",
  SET_LIMIT: "SET_LIMIT",
  UPDATE_LEAD_TYPE_IN_LIST: "QUOTE_UPDATE_LEAD_TYPE_IN_LIST",
};

export const quoteAction = {
  getAllContactStart: (data) => ({
    type: quoteMap.GET_ALL_QUOTE_START,
    payload: data,
  }),
  getAllContactSuccess: (data) => ({
    type: quoteMap.GET_ALL_QUOTE_SUCCESS,
    payload: data,
  }),
  getAllContactError: (errors) => ({
    type: quoteMap.GET_ALL_QUOTE_ERROR,
    payload: { errors },
  }),
  refreshContactList: () => ({ type: quoteMap.REFRESH_QUOTE_LIST }),
  searchTextChange: (data) => ({
    type: quoteMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  setContactBatchNumber: (data) => ({
    type: quoteMap.SET_QUOTE_BATCH_NUMBER,
    payload: data,
  }),
  getContactStart: (data) => ({
    type: quoteMap.GET_QUOTE_START,
    payload: data,
  }),
  getContactSuccess: (data) => ({
    type: quoteMap.GET_QUOTE_SUCCESS,
    payload: data,
  }),
  getContactError: (errors) => ({
    type: quoteMap.GET_QUOTE_ERROR,
    payload: { errors },
  }),
  getContactError: (errors) => ({
    type: quoteMap.GET_QUOTE_ERROR,
    payload: { errors },
  }),
  getQuotePageNameListSuccess: (data) => ({
    type: quoteMap.GET_QUOTE_PAGE_NAME_LIST_SUCCESS,
    payload: data,
  }),
  setAudioType: (data) => ({
    type: quoteMap.SET_AUDIO_TYPE,
    payload: data,
  }),
  setLeadType: (data) => ({
    type: quoteMap.SET_LEAD_TYPE,
    payload: data,
  }),
  setCallOutcomeFilter: (callOutcome) => ({
    type: quoteMap.SET_CALL_OUTCOME_FILTER,
    payload: callOutcome,
  }),
  setLimit: (data) => ({
    type: quoteMap.SET_LIMIT,
    payload: data,
  }),
  // Patch a single record's leadType inside ContactList.records — used by the
  // listing page dropdown so it doesn't clobber the whole list (unlike
  // getContactSuccess, which replaces ContactList with a single record, meant
  // for the detail/view page).
  updateLeadTypeInList: (id, leadType) => ({
    type: quoteMap.UPDATE_LEAD_TYPE_IN_LIST,
    payload: { id, leadType },
  }),
};
